import AssignProjectDialog from './AssignProjectDialog';

export default AssignProjectDialog;
